export default __webpack_public_path__ + "static/media/invoice-preview-img.a4e239f3.png";